/*
 * Pagina del Dashboard: Permite navegar dentro de la aplicacion
 * Muestra la barra de navegacion, el acceso al perfil y renderiza el modulo y proceso seleccionado
 */

import {
  Dashboard,
  DashboardMain,
  MenuWrapper,
  MenuItems,
  HeaderBoxLeft,
  HeaderBoxRight,
  HeaderWrapper,
  HeaderSearch,
  HeaderUser,
  HeaderUserItem,
  Divider,
  FloatingToolbox,
  shootToast,
  Agentflo,
  Button,
} from "codekit";

import DashboardChildRoute from "./DashboardChildRoute";
import MyProfile from "./MyProfile";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getDataUser,
  getMenuUser,
  signOut,
  setMenuUser,
  setModuleURL,
  getIsReplaceUser,
  getInfoUserReplace,
  getInfoUser,
  getIsOtherUser,
  getPreviewInfoUser,
  setReturnUser,
  getSecuenceHistory,
} from "../libs/redux/slices/authSlice/authSlice";
import {
  getModuleSelected,
  getProcesSelected,
  reset,
  setModuleSelected,
  setProcesSelected,
} from "../libs/redux/slices/MenuSlice/menuSlice";
import { useLogoutMutation } from "../libs/redux/slices/authSlice/authApiSlice";
import { useOrderMenuMutation, useOrderProcessMutation } from "../libs/redux/slices/MenuSlice/menuApliSlice";
import { resetFiltersGraph } from "../libs/redux/slices/Graficsx/graficsxSlice";

import capitalizeWord from "../utils/capitalize-words";
import generateAvatarLetters from "../utils/avatar-letters-generator";
import { resetConsult } from "../libs/redux/slices/consultSlice/consultSlice";
import { resetCustomFilters } from "../libs/redux/slices/trackingSlice/trackingSlice";
import { Notificx } from "./Notificx";
import Chatboxx from "../components/Agentexx/Chatboxx";
import Usertmpx from "./Usertmpx";
import Vercomo from "../components/Usuarios/Vercomo/Vercomo";
import Vercomob from "../components/Usuarios/Vercomo/Vercomob";
import Entrarcu from "../components/Usuarios/Entrarcu/Entrarcu";
import Entrarcub from "../components/Usuarios/Entrarcu/Entrarcub";
import { useReturnUserMutation, useDeleteHistoryMutation } from "../libs/redux/slices/AdminxxxSlice/adminxxxApiSlice";

import Causapay from "../components/Modimpxx/Testimpx/Causapay/Causapay";
import { useUserAbsentMutation, useGetUserAusentMutation, useGetTurnsTodayByUserQuery, useSetUserAusentMutation } from "../libs/redux/slices/authSlice/authApiSlice";
import Creadoxx from "../components/Modimpxx/Trackimp/Creadoxx/Creadoxx";
import { getCheckedRows, getRetornoTablero, setRetornoTablero } from "../libs/redux/slices/trackingSlice/trackingSlice";
import Userause from "../components/Userause/Userause";
import Trasladv from "../components/Modimpxx/Testimpx/Trasladv";
import Pagocsuc from "../components/Modimpxx/Testimpx/Pagocsuc/Pagocsuc";
import Gestcont from "../components/Modimpxx/Testimpx/Gestcont/Gestcont";
import { useGetCustomsActivityQuery } from "../libs/redux/slices/Modimpxx/Customsai/customsaiApiSlice";

const DashboardPage = () => {
  const dispatch = useDispatch();

  const userData = useSelector(getDataUser);
  const menuData = useSelector(getMenuUser);

  const { MODIDXXX, MODURLXX } = useSelector(getModuleSelected);
  const { PRODURLX } = useSelector(getProcesSelected);
  const { USREMAXX, USRNOMXX, USRIDXXX } = userData;

  const { data: turnsByUser } = useGetTurnsTodayByUserQuery({ USRIDXXX });

  const [orderMenu] = useOrderMenuMutation();
  const [orderProcess] = useOrderProcessMutation();
  const [logout] = useLogoutMutation();

  const [menuDataMap, setMenuDataMap] = useState([]);
  const [showMyProfile, setShowMyProfile] = useState(false);
  const [isAusent, setIsAusent] = useState(false);
  const [openModalAusent, setOpenModalAusent] = useState(false);
  const isReplaceUser = useSelector(getIsReplaceUser);
  const [infoUser, setInfoUser] = useState({ USREMAXX, USRNOMXX, USRIDXXX });
  const infoUserReplace = useSelector(getInfoUserReplace);
  const [isCauPay, setIsCauPay] = useState(false);
  const [isNuevoDO, setIsNuevoDO] = useState(false);
  // Asistente: Customs AI notifica al usuario que originó la tarea y el
  // panel se abre solo cuando llega actividad nueva suya.
  const [isAgentOpen, setIsAgentOpen] = useState(false);
  // selectFromResult: SOLO los datos — sin esto, cada ciclo de polling
  // notifica isFetching y re-renderiza el dashboard completo (titileo).
  const { data: dataCustomsMine } = useGetCustomsActivityQuery(
    { mine: true },
    {
      pollingInterval: 20000,
      skip: !USRIDXXX,
      selectFromResult: ({ data }) => ({ data }),
    }
  );
  const customsEvents = dataCustomsMine?.data ?? [];
  useEffect(() => {
    if (customsEvents.length === 0) return;
    // localStorage (no session): una recarga no debe re-abrir por eventos viejos
    const seenKey = `customsai-abiertos-${USRIDXXX || "anon"}`;
    const seen = new Set(JSON.parse(localStorage.getItem(seenKey) ?? "[]"));
    const fresh = customsEvents.filter((e) => e.EVENTOID && !seen.has(e.EVENTOID));
    if (fresh.length > 0) {
      setIsAgentOpen(true);
      fresh.forEach((e) => seen.add(e.EVENTOID));
      localStorage.setItem(seenKey, JSON.stringify([...seen].slice(-300)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customsEvents]);
  const userInfo = useSelector(getInfoUser);
  const isOtherUser = useSelector(getIsOtherUser);
  const previewUserData = useSelector(getPreviewInfoUser);
  const [returnUserMutation] = useReturnUserMutation();
  const [deleteHistory] = useDeleteHistoryMutation();
  const [userAbsent] = useUserAbsentMutation();
  const [getUserAusent] = useGetUserAusentMutation();
  const [setUserAusent] = useSetUserAusentMutation();
  const SECINGID = useSelector(getSecuenceHistory);
  const selectedRows = useSelector(getCheckedRows);
  const [isTraslado, setIsTraslado] = useState(false);
  const [isCauPayBranch, setIsCauPayBranch] = useState(false);
  const [isGestcont, setIsGestcont] = useState(false);

  const toDateAt = (dateStr, timeStr) => new Date(`${dateStr}T${timeStr}`);

  // Verificamos el permiso del boton pago causaciones
  const bPermCau = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 101) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 103);
        }
        return false;
      });
    }
    return false;
  });

  // Verificamos el permiso del boton nuevo DO
  const bPermNuevoDO = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 100) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 100);
        }
        return false;
      });
    }
    return false;
  });

  // Verificamos el permiso del boton traslado anticipos
  const aplyTraslado = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 101) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 107);
        }
        return false;
      });
    }
    return false;
  });

  // Verificamos el permiso del boton pago causaciones sucursales
  const applyCasuPayBranch = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 101) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 108);
        }
        return false;
      });
    }
    return false;
  });

  // Verificamos el permiso del boton tarea gestion contable
  const applyGestcont = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 101) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 109);
        }
        return false;
      });
    }
    return false;
  });

  const toggleAusent = async () => {
    try {
      const response = await getUserAusent(USRIDXXX).unwrap();
      if (!response.data.ausente) {
        console.log("El usuario ya está marcado como ausente.");
        setOpenModalAusent(true);
      } else {
        await userAbsent({ 'USRIDXXX': USRIDXXX }).unwrap();
        setIsAusent((prev) => !prev);
      }
    } catch (error) {
      console.error("Error al cambiar el estado de ausencia:", error);
    }
  };

  const toggleTurns = async () => {
    try {
      const dayData = turnsByUser?.data;
      const turns = dayData?.TURNSXXX ?? [];

      if (!Array.isArray(turns) || turns.length === 0) {
        shootToast({
          variant: 'error',
          text: 'No Tiene Ningún Turno Asignado',
          duration: 5000,
        });
        return;
      }

      const dateStr = dayData.DATEXXXX;

      const ranges = turns
        .flatMap(t =>
          (t.RANGESXX ?? []).map(r => ({
            start: toDateAt(dateStr, r.STARTXXX),
            end:   toDateAt(dateStr, r.ENDXXXXX),
          }))
        )
        .sort((a, b) => a.start - b.start);

      if (ranges.length === 0) {
        shootToast({
          variant: 'error',
          text: 'No Tiene Ningún Turno Asignado',
          duration: 5000,
        });
        return;
      }

      const now = new Date();

      const current = ranges.find(r => now >= r.start && now < r.end);
      if (current) {
        shootToast({
          variant: 'error',
          text: 'Su Turno Aun Sigue Activo, Por Favor Ciérrelo Cuando Sea Oportuno',
          duration: 5000,
        });
        return;
      }

      const lastRange = ranges[ranges.length - 1];

      if (now >= lastRange.end) {
        await setUserAusent(USRIDXXX).unwrap();
        return;
      }
      shootToast({
        variant: 'error',
        text: 'Su Turno Aun Sigue Activo, Por Favor Ciérrelo Cuando Sea Oportuno',
        duration: 5000,
      });
    } catch (error) {
      console.error('Error al validar el turno:', error);
      shootToast({
        variant: 'error',
        text: 'Ocurrió un error al validar su turno. Intente nuevamente.',
        duration: 5000,
      });
    }
  };


  /**
   * Hook que establece los elementos del menu de navegacion y actualiza su estado activo cuando se seleccionan
   */
  useEffect(() => {
    /**
     * Funcion para guardar el modulo y proceso elegido del menu de navgacion
     */
    const onSelectOption = (moduleItem, processItem) => {
      dispatch(setModuleSelected(moduleItem));
      dispatch(setProcesSelected(processItem));
      setShowMyProfile(false);
    };

    /**
     * Funcion que genera los items del menu de navegacion
     */
    const menuDataMapper = () => {
      return menuData.map((menu) => {
        let isActive = false;

        //Se compara por MODIDXXX y no por MODURLXX: la URL puede repetirse entre
        //módulos —Finalización apunta a 'Modimpxx' porque su backend vive ahí—, y
        //comparando por URL se pintaban activos los dos a la vez. El id es la
        //identidad del módulo y no se repite (root/gestionsiaco#287).
        if (MODIDXXX) {
          isActive = menu.MODIDXXX === MODIDXXX;
        }

        const menuDataItem = {
          id: menu.MODIDXXX,
          description: menu.MODDESXX,
          url: menu.MODURLXX,
          icon: `${menu.MODICOXX}`,
          isActive: isActive,
          items: menu.CIMS0004.map((subItem) => ({
            id: subItem.PROIDXXX,
            description: subItem.PRODESXX,
            url: subItem.PRODURLX,
            onClick: () => {
              onSelectOption(menu, subItem);
            },
          })),
        };
        return menuDataItem;
      });
    };

    const menuDataMap = menuDataMapper();

    setMenuDataMap(menuDataMap);
  }, [MODIDXXX, MODURLXX, menuData, dispatch]);

  /**
   * Hook que setea la URL del modulo para la cabecera de la peticion
   */
  useEffect(() => {
    if (MODURLXX) {
      dispatch(setModuleURL(MODURLXX.toLowerCase()));
    }
  }, [MODURLXX, dispatch]);

  /**
   * Funcion para cerrar sesion del usuario
   */
  const onLogout = async () => {
    if (isOtherUser) {
      await deleteHistory(SECINGID);
    }
    await logout();
    dispatch(signOut());
    dispatch(reset());
    dispatch(resetConsult());
    dispatch(resetCustomFilters());
    dispatch(resetFiltersGraph());
  };

  /**
   * Funcion que vacia el modulo y proceso elegido
   */
  const handleClickHome = () => {
    dispatch(setModuleSelected(""));
    dispatch(setProcesSelected(""));
    setShowMyProfile(false);
  };

  //Retorno al tablero de origen de un drill-down del kit (Diego 2026-09-15):
  //el tracking al que llego el usuario ofrece "Volver" a la pantalla desde la
  //que salto. Si salio de Mi Puesto (el Inicio) ya existe el boton flotante propio.
  const retornoTablero = useSelector(getRetornoTablero);
  const bRetornoTablero = Boolean(retornoTablero) && retornoTablero?.enDestino !== false && `${MODURLXX}.${PRODURLX}` === retornoTablero?.target
    && retornoTablero?.origen?.tipo !== "INICIO" && retornoTablero?.origen?.modulo !== "Mipuesto";
  const handleVolverTablero = () => {
    const destino = retornoTablero;
    //Se conserva el widget de origen (sin enDestino): la tarjeta se desplaza sola al montarse y lo limpia
    dispatch(setRetornoTablero(destino?.widget ? { ...destino, enDestino: false } : null));
    if (!destino || destino.origen?.tipo === "INICIO") {
      handleClickHome();
      return;
    }
    const menuOrigen = menuData.find((menu) => menu.MODURLXX === destino.origen.modulo);
    const processOrigen = menuOrigen?.CIMS0004?.find((process) => process.PRODURLX === destino.origen.proceso);
    if (menuOrigen && processOrigen) {
      dispatch(setModuleSelected(menuOrigen));
      dispatch(setProcesSelected(processOrigen));
      return;
    }
    handleClickHome();
  };
  //Regreso rapido a Mi Puesto (el Inicio) desde cualquier pantalla (Diego 2026-09-16)
  const handleVolverMipuesto = () => {
    const destino = retornoTablero;
    if (destino?.origen?.tipo === "INICIO") {
      dispatch(setRetornoTablero(destino.widget ? { ...destino, enDestino: false } : null));
    }
    handleClickHome();
  };

  /**
   * Funcion para reordenar los elementos del menu
   */
  const reorderMenuData = (context) => {
    const indexes = context.item.indexes;
    const newIndex = indexes.new;
    const previousIndex = indexes.previous;

    const newMenuData = [...menuData];
    const [removed] = newMenuData.splice(previousIndex, 1);
    newMenuData.splice(newIndex, 0, removed);
    return newMenuData;
  };

  /**
   * Funcion que sirve para guardar el nuevo orden del menu
   */
  const setNewMenuOrder = async (newDataMenu) => {
    const data = newDataMenu.map((module) => {
      return module.MODIDXXX;
    });
    await orderMenu({ MODIDXXX: data }).unwrap();
  };

  /**
   * Funcion que maneja el arrastrado de los items del menu
   */
  const handleMenuDragging = (context) => {
    // Set new menuDataMap order
    const items = context._newItems;
    setMenuDataMap(items);

    // Set new menuData order
    const newMenuData = reorderMenuData(context);
    dispatch(setMenuUser(newMenuData));
    setNewMenuOrder(newMenuData);
  };

  /**
   * Funcion que reordena los procesos (CIMS0004) de un modulo especifico dentro de menuData
   */
  const reorderSubitemsData = (moduleId, context) => {
    const indexes = context.subitem.indexes;

    return menuData.map((module) => {
      if (module.MODIDXXX !== moduleId) return module;

      const newProcesses = [...module.CIMS0004];
      const [removed] = newProcesses.splice(indexes.previous, 1);
      newProcesses.splice(indexes.new, 0, removed);
      return { ...module, CIMS0004: newProcesses };
    });
  };

  /**
   * Funcion que sirve para guardar el nuevo orden de los procesos de un modulo
   */
  const setNewSubitemsOrder = async (moduleId, newProcesses) => {
    const data = newProcesses.map((process) => process.PROIDXXX);
    await orderProcess({ MODIDXXX: moduleId, PROIDXXX: data }).unwrap();
  };

  /**
   * Funcion que maneja el arrastrado de los procesos dentro de un modulo
   */
  const handleSubitemsDragging = (item, context) => {
    // Set new menuDataMap order for that module's subitems
    setMenuDataMap((prevMenuDataMap) =>
      prevMenuDataMap.map((menuItem) =>
        menuItem.id === item.id ? { ...menuItem, items: context._newSubitems } : menuItem
      )
    );

    // Set new menuData order
    const newMenuData = reorderSubitemsData(item.id, context);
    dispatch(setMenuUser(newMenuData));

    const reorderedModule = newMenuData.find((module) => module.MODIDXXX === item.id);
    setNewSubitemsOrder(item.id, reorderedModule?.CIMS0004 ?? []);
  };

  const returnUser = async () => {
    let userData = { ...previewUserData };
    let { token: TOKENXXX } = userData.data[0];

    await returnUserMutation({ SECINGID: SECINGID, body: { TOKENXXX: TOKENXXX } })
      .unwrap()
      .then(() => {
        dispatch(setReturnUser({ userData }));
        handleClickHome();
      })
      .catch();
  };

  //Hook que controla el cambio de informacion para el usuario reemplazo
  useEffect(() => {
    if (Object.entries(infoUserReplace).length > 0) {
      setInfoUser({ ...infoUserReplace });
    }
  }, [infoUserReplace]);

  useEffect(() => {
    if (Object.entries(userInfo).length > 0 && !isReplaceUser) {
      setInfoUser({ ...userInfo });
    }
  }, [userInfo, isReplaceUser]);

  //Funcion para validar la creacion de un nuevo DO
  const handleOpenNuevoDO = () => {

    const isDoctraxx = MODURLXX === "Doctraxx";
    const rowsCount = selectedRows.length;

    if (rowsCount === 0) {
      if ((isDoctraxx && PRODURLX === "Saldoctr") || (MODURLXX === "Faccomxx" && PRODURLX === "Salfactx")) {
        shootToast({
          variant: 'warning',
          text: `Debe seleccionar un ${isDoctraxx ? 'Documento de Transporte' : 'Saldo de Documentos'} para crear uno nuevo.`,
          duration: 5000,
        });
        return;
      }
      setIsNuevoDO(true);
      return;
    }

    const allWithSaldo = selectedRows.every(row => row.SAFAESTX === "CON SALDO" || row.DOCTRAES === "CON SALDO");
    if (!allWithSaldo) {
      shootToast({
        variant: 'error',
        text: 'No es posible crear el DO, el estado no se encuentra con saldo.',
        duration: 5000,
      });
      return;
    }

    if (isDoctraxx) {
      if (rowsCount > 1) {
        const firstDtrcnico = selectedRows[0].DTRCNICO;
        const allSameDtrcnico = selectedRows.every(row => row.DTRCNICO === firstDtrcnico);

        if (!allSameDtrcnico) {
          shootToast({
            variant: 'warning',
            text: 'Los Documentos de transporte deben contar con el mismo Cliente, por favor valide.',
            duration: 5000,
          });
          return;
        }

        const areAllZonaFranca = selectedRows.every(row =>
          row.DEPDESXX && row.DEPDESXX.toLowerCase().includes("zona franca")
        );

        if (!areAllZonaFranca) {
          shootToast({
            variant: 'warning',
            text: 'Solo puede seleccionar un Documento de Transporte si el depósito no es Zona Franca.',
            duration: 5000,
          });
          return;
        }
        if (areAllZonaFranca) {
          const firstDepId = selectedRows[0].DEPIDXXX;
          const allSameDepId = selectedRows.every(row => row.DEPIDXXX === firstDepId);

          if (!allSameDepId) {
            shootToast({
              variant: 'warning',
              text: 'Los Documentos de transporte no cuentan con el mismo Depósito por favor valide.',
              duration: 5000,
            });
            return;
          }
        }
      }
      const firstClientId = selectedRows[0].CLIIDXXX;
      const allSameClient = selectedRows.every(row => row.CLIIDXXX === firstClientId);

      if (allSameClient) {
        setIsNuevoDO(true);
      } else {
        shootToast({
          variant: 'warning',
          text: 'Debe seleccionar Saldos de Documentos de un mismo cliente.',
          duration: 5000,
        });
      }
      return;
    }

    if (rowsCount > 0) {
      const firstClientId = selectedRows[0].CLIIDXXX;
      const allSameClient = selectedRows.every(row => row.CLIIDXXX === firstClientId);

      if (allSameClient) {
        setIsNuevoDO(true);
      } else {
        shootToast({
          variant: 'warning',
          text: 'Debe seleccionar Saldos de Documentos de un mismo cliente.',
          duration: 5000,
        });
      }
    }
  };

  return (
    <Dashboard>
      <HeaderWrapper>
        <HeaderBoxLeft>
          <HeaderSearch />
        </HeaderBoxLeft>
        <HeaderBoxRight>
          <Notificx isAusent={isAusent} />
          <Agentflo open={isAgentOpen} onOpenChange={setIsAgentOpen}>
            <Chatboxx customsEvents={customsEvents} />
          </Agentflo>
          <FloatingToolbox
            initialPosition={{ x: 630, y: 20 }}
            persistKey="dashboard-floating-toolbox-position"
            buttons={[
              // Si bPermNuevoDO es true, mostramos el botón
              bPermNuevoDO && {
                icon: "plus",
                tooltip: "Crear Nuevo DO",
                variant: "primary",
                onClick: () => {
                  handleOpenNuevoDO()
                },
              },
              // Si bPermCau es true, mostramos el botón
              bPermCau && {
                icon: "coin",
                tooltip: "Solicitar Pago Causaciones",
                variant: "secondary",
                onClick: () => {
                  setIsCauPay(true);
                },
              },
              aplyTraslado && {
                icon: "financing-config",
                tooltip: "Solicitud de Traslado",
                variant: "secondary",
                onClick: () => {
                  setIsTraslado(true);
                },
              },
              applyCasuPayBranch && {
                icon: "file-money",
                tooltip: "Solicitar Pago Causaciones Sucursales",
                variant: "secondary",
                onClick: () => {
                  setIsCauPayBranch(true);
                },
              },
              applyGestcont && {
                icon: "financing-config",
                tooltip: "Gestión Contable",
                variant: "secondary",
                onClick: () => {
                  setIsGestcont(true);
                },
              },
            ].filter(Boolean)} // Usamos .filter(Boolean) para eliminar valores null
          />
          {isCauPay && <Causapay setIsCauPay={setIsCauPay} />}
          {/* Fuera de Mi Puesto (moduleSelected vacio = home): retorno rapido siempre visible */}
          {Boolean(MODURLXX) && MODURLXX !== "Mipuesto" && (
            <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 40, display: "flex", gap: 8 }}>
              {bRetornoTablero && (
                <Button variant="secondary" size="m" icon="arrow-left" onClick={handleVolverTablero}>
                  {retornoTablero.etiqueta}
                </Button>
              )}
              <Button variant="primary-bold" size="m" icon="arrow-left" onClick={handleVolverMipuesto}>
                Mi Puesto
              </Button>
            </div>
          )}
          {isNuevoDO && <Creadoxx handleClose={() => setIsNuevoDO(false)} row={selectedRows} setShowCreateDo={setIsNuevoDO} modurlxx={MODURLXX} isFromToolbox />}
          {isTraslado && <Trasladv setTraslant={setIsTraslado} />}
          {isCauPayBranch && <Pagocsuc setIsCauPayBranch={setIsCauPayBranch} />}
          {isGestcont && <Gestcont setGestcont={setIsGestcont} />}

          <HeaderUser
            image={`${infoUser.USRURLFO && infoUser.USRURLFO !== ""
              ? infoUser?.USRURLFO
              : generateAvatarLetters(`${infoUser.USRNOMXX}`)
              }`}
            name={capitalizeWord(infoUser.USRNOMXX)}
            email={infoUser.USREMAXX.toLowerCase()}
            isReplace={isReplaceUser}
            isAusent={isAusent}
          >
            <HeaderUserItem icon="user-inactive" onClick={toggleTurns}>
              Cerrar Turno
            </HeaderUserItem>
            {!isOtherUser ? (
              <HeaderUserItem icon="user" onClick={() => setShowMyProfile(true)}>
                Mi Perfil
              </HeaderUserItem>
            ) : (
              <HeaderUserItem icon="user-change" onClick={() => returnUser()}>
                Volver a Mi Perfil
              </HeaderUserItem>
            )}
            <Usertmpx handleClickHome={handleClickHome} />
          <Vercomo />
          <Entrarcu />
            <HeaderUserItem icon="user-inactive" onClick={toggleAusent}>
              Activar / Inactivar Ausente
            </HeaderUserItem>
            <Divider />
            <HeaderUserItem icon="logout" onClick={onLogout}>
              Cerrar sesión
            </HeaderUserItem>
          </HeaderUser>
        </HeaderBoxRight>
      </HeaderWrapper>
      <MenuWrapper>
        <HeaderUser
          image={`${infoUser.USRURLFO && infoUser.USRURLFO !== ""
            ? infoUser?.USRURLFO
            : generateAvatarLetters(`${infoUser.USRNOMXX}`)
            }`}
          name={capitalizeWord(infoUser.USRNOMXX)}
          email={infoUser.USREMAXX.toLowerCase()}
          isInsideMenu
          isReplace={isReplaceUser}
        >
          <HeaderUserItem icon="user-inactive" onClick={toggleTurns}>
            Cerrar Turno
          </HeaderUserItem>
          <HeaderUserItem icon="user" onClick={() => setShowMyProfile(true)}>
            Mi Perfil
          </HeaderUserItem>
          <Usertmpx handleClickHome={handleClickHome} />
          <Vercomo />
          <Entrarcu />
          <HeaderUserItem icon="user-inactive" onClick={toggleAusent}>
            Activar / Inactivar Ausente
          </HeaderUserItem>
          <HeaderUserItem icon="logout" onClick={onLogout}>
            Cerrar sesión
          </HeaderUserItem>
        </HeaderUser>
        <MenuItems
          labelHome="Mi Puesto"
          onClickHome={handleClickHome}
          onMenuDragged={handleMenuDragging}
          onSubitemsDragged={handleSubitemsDragging}
          items={menuDataMap.filter((menu) => menu.url !== "Mipuesto")}
        />
      </MenuWrapper>
      <DashboardMain>
        <Vercomob handleClickHome={handleClickHome} />
        <Entrarcub handleClickHome={handleClickHome} onVolver={returnUser} />
        {showMyProfile ? <MyProfile handleClickHome={handleClickHome} /> : <DashboardChildRoute />}
        {openModalAusent && <Userause infoUser={infoUser} setOpenModalAusent={setOpenModalAusent} setIsAusent={setIsAusent} />}
      </DashboardMain>
    </Dashboard>
  );
};

export default DashboardPage;
